import { configureStore } from "@reduxjs/toolkit";
import userTokenSlice from "./slices/userTokenSlice";

import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import persistStore from "redux-persist/es/persistStore";
import timeSlice from "./slices/timeSlice";
import questionsSlice from "./slices/questionsSlice";
import indexSlice from "./slices/indexSlice";
import opponentPlayerSlice from "./slices/opponentPlayerSlice";
import userPlayerSlice from "./slices/userPlayerSlice";
import languageSlice from "./slices/languageSlice";
import activeTileSlice from "./slices/wordGameSlice/activeTileSlice";
import tileWordSlice from "./slices/wordGameSlice/tileWordSlice";
import enteredWordSlice from "./slices/wordGameSlice/enteredWordSlice";
import targetWordSlice from "./slices/wordGameSlice/targetWordSlice";
import wordResultSlice from "./slices/wordGameSlice/wordResult";
import targetWord3Slice from "./slices/wordGameSlice/targetWord3Slice";
import word3ResultSlice from "./slices/wordGameSlice/word3Result";
import wordTimeSlice from "./slices/wordGameSlice/wordTimeSlice";
import tilesSliceMediumMode from "./slices/xoGameSlice/tilesSliceMedium";
import playerSlice from "./slices/xoGameSlice/playerSlice";
import xoGameOverSlice from "./slices/xoGameSlice/xoGameOverSlice";
import xoModalSlice from "./slices/xoGameSlice/xoModalSlice";
import tiles5Slice from "./slices/xoGameSlice/tiles5Slice";
import tiles7Slice from "./slices/xoGameSlice/tiles7Slice";
import tilesSlice from "./slices/xoGameSlice/tilesSlice";
import tilesSliceEasyMode from "./slices/xoGameSlice/tilesSliceEasy";
import tilesSliceHardMode from "./slices/xoGameSlice/tilesSliceHard";
import userZipGameTokenSlice from "./slices/userZipGameTokenSlice";
import zipGameSlice from "./slices/zipGameSlice/zipGameSlice";
import msisdnReducer from "./slices/msisdnSlice";
import megaQuizReducer from "./slices/Megaquizslice";

const rootReducer = combineReducers({
  userTokenSlice: userTokenSlice.reducer,
  opponentPlayerSlice: opponentPlayerSlice.reducer,
  timeSlice: timeSlice.reducer,
  questionsSlice: questionsSlice.reducer,
  indexSlice: indexSlice.reducer,
  userPlayerSlice: userPlayerSlice.reducer,

  // word game slices 

  activeTileSlice: activeTileSlice.reducer,
  tileWordSlice: tileWordSlice.reducer,
  enteredWordSlice: enteredWordSlice.reducer,
  targetWordSlice: targetWordSlice.reducer,
  wordResultSlice: wordResultSlice.reducer,
  targetWord3Slice: targetWord3Slice.reducer,
  word3ResultSlice: word3ResultSlice.reducer,
  wordTimeSlice: wordTimeSlice.reducer,

  // xo game slice
  tilesSliceMediumMode:tilesSliceMediumMode.reducer,
  playerSlice:playerSlice.reducer,
  xoGameOverSlice:xoGameOverSlice.reducer,
  xoModalSlice:xoModalSlice.reducer,
  tiles5Slice:tiles5Slice.reducer,
  tiles7Slice:tiles7Slice.reducer,
  tilesSlice:tilesSlice.reducer,
  tilesSliceEasyMode:tilesSliceEasyMode.reducer,
  tilesSliceHardMode:tilesSliceHardMode.reducer,

  // zip game slice
  userZipGameTokenSlice:userZipGameTokenSlice.reducer,
  zipGameSlice:zipGameSlice.reducer,

  //Megaquize msisdn
   msisdn: msisdnReducer,
    megaQuiz: megaQuizReducer
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: {
    persisted: persistedReducer,
    languageSlice: languageSlice.reducer,
  },
});

export default store;
export const persistor = persistStore(store);